@let setupGuideDrawerOpened = setupGuideDrawerOpened$ | async;
@let shouldMenuBeOpen = (collapseMenu$ | async) === false && (!setupGuideDrawerOpened || !isSetupGuideDrawerExpanded);
@let shouldUseOverModeForMenu = (mode$ | async) === 'over' || (setupGuideDrawerOpened && isSetupGuideDrawerExpanded);

<mat-drawer-container class="drawer-container" [hasBackdrop]="collapseMenu$ | async">
  <mat-drawer
    #drawer
    [mode]="shouldUseOverModeForMenu ? 'over' : 'push'"
    position="start"
    [opened]="shouldMenuBeOpen"
    (closedStart)="onClosedStart()"
    (openedStart)="onOpenedStart()"
    class="menu-drawer"
  >
    <ng-scrollbar>
      <!-- side menu collapse button -->
      <button
        class="collapse-button"
        (click)="drawer.toggle()"
        [class.visible]="setupGuideDrawerOpened && isSetupGuideDrawerExpanded"
        [ngStyle]="{ color: getChipTextColor(auctionStatus$ | async, isAuctionHidden$ | async) }"
      >
        <gb-icon icon="menu"> </gb-icon>
      </button>
      <ng-content select="[sidenavHeader]"> </ng-content>

      @if (
        {
          sidenavItems: sidenavItems$ | async,
          desktopView: desktopView$ | async,
        };
        as obs
      ) {
        <div class="sidenav-items-container">
          @for (sidenavItem of obs.sidenavItems; track sidenavItem) {
            <div [ngClass]="getClass(sidenavItem)" class="sidenav-item-container">
              <!-- hint -->
              @if (!sidenavItem.expanded && (getParentSidenavItemHints$(sidenavItem) | async)) {
                <gb-sidenav-hint
                  [hints$]="getParentSidenavItemHints$(sidenavItem)"
                  [optional$]="getParentSidenavHintOptional$(sidenavItem)"
                  [hintHoverText$]="sidenavItem.hintHoverText$"
                >
                </gb-sidenav-hint>
              }
              <!-- sidenav button -->
              @if (!sidenavItem.isDivider) {
                <div
                  class="sidenav-item sidenav-parent-item"
                  [ngClass]="getItemClass(sidenavItem) | async"
                  [gbRouteNewTab]="getRouterLink(sidenavItem)"
                  matRipple
                  [disabled]="hasSubItems(sidenavItem)"
                  [matRippleColor]="'rgba(255, 255, 255, 0.074)'"
                  (click)="toggle(sidenavItem); hideMenuOnMobile(obs.desktopView, sidenavItem)"
                >
                  <ng-container *ngTemplateOutlet="labelTemplate; context: { $implicit: sidenavItem }"></ng-container>
                  @if (hasSubItems(sidenavItem)) {
                    <gb-icon class="expand-icon" [library]="IconLibrary.material" icon="keyboard_arrow_up"></gb-icon>
                  }
                </div>
              }
              <!-- items dropdown -->
              @if (hasSubItems(sidenavItem)) {
                <div class="sub-items-container">
                  @for (sidenavSubItem of sidenavItem.subItems; track sidenavSubItem) {
                    <div
                      class="sidenav-item"
                      [gbRouteNewTab]="getSubItemRouterLink(sidenavSubItem)"
                      [params]="sidenavSubItem.params"
                      matRipple
                      [matRippleColor]="'rgba(255, 255, 255, 0.074)'"
                      (click)="hideMenuOnMobile(obs.desktopView, sidenavSubItem); onClick(sidenavSubItem, $event)"
                    >
                      <gb-sidenav-hint [hints$]="sidenavSubItem.hints$" [optional$]="sidenavSubItem.hintsOptional$">
                      </gb-sidenav-hint>
                      <ng-container
                        *ngTemplateOutlet="labelTemplate; context: { $implicit: sidenavSubItem }"
                      ></ng-container>
                      @if (sidenavSubItem.additionalLabelText$ | async; as additionalLabelText) {
                        <span class="additional-label">{{ additionalLabelText }}</span>
                      }
                    </div>
                  }
                </div>
              }
              <!-- divider -->
              @if (!!sidenavItem.isDivider) {
                <div class="sidenav-item-subtitle">
                  <span>
                    {{ sidenavItem.label || '' | translate }}
                  </span>
                </div>
              }
            </div>
          }
        </div>
      }
    </ng-scrollbar>
  </mat-drawer>
  <mat-drawer
    #setupGuideDrawer
    mode="side"
    position="end"
    [opened]="setupGuideDrawerOpened"
    class="setup-guide-drawer"
    [style.width.px]="setupGuideDrawerWidthPx"
    [style.min-width.px]="setupGuideDrawerMinWidthPx"
    [style.max-width.px]="setupGuideDrawerMaxWidthPx"
  >
    @if (setupGuideDrawerOpened) {
      <gb-setup-guide-sidebar></gb-setup-guide-sidebar>
    }
  </mat-drawer>

  <mat-drawer-content
    class="sidenav-container"
    [class.setup-guide-opened]="setupGuideDrawerOpened"
    [style.--setup-guide-drawer-width]="setupGuideDrawerWidthPx + 'px'"
  >
    @if (!drawer.opened) {
      <button class="sidenav-toggle-button" mat-fab (click)="drawer.toggle()">
        <gb-icon [icon]="'list'"> </gb-icon>
      </button>
    }
    <ng-content></ng-content>
  </mat-drawer-content>
</mat-drawer-container>

<ng-template #labelTemplate let-item>
  <div class="label-container">
    @if (item.icon) {
      <gb-icon [icon]="item.icon" [library]="item.iconLibrary" height="20px"></gb-icon>
    }
    <span [translate]="item.label"></span>
    @if (item.shouldShowBadge$ | async) {
      @if (item.badgeText$ | async; as badgeText) {
        <span class="sidenav-badge" [translate]="'' + badgeText"></span>
      }
    }
  </div>

  @if (item.dynamicComponent) {
    <ng-container *ngComponentOutlet="item.dynamicComponent"></ng-container>
  }
</ng-template>
